import React from "react";
import { NavLink, useLocation } from "react-router-dom";

const DefaultHeader = () => {
  const location = useLocation();

  // Active state checks
  const isJobsRoute = ["/user/jobs", "/user/job-apply"].some((route) => location.pathname.startsWith(route));
  const isFreelanceRoute = location.pathname === "/job-category" || location.pathname === "/testimonial";

  const navLinkClass = "hover:text-[#00B074] transition duration-200";
  const activeClass = "text-[#00B074] font-semibold";

  return (
    <div className="relative">
      <nav className="bg-white shadow sticky top-0 z-50">
        <div className="max-w-7xl mx-auto flex items-center justify-between px-4 py-4">
          <NavLink to="/" className="flex items-center text-center">
            <h1 className="text-2xl font-bold text-[#00B074]">SymLink TECH</h1>
          </NavLink>

          <ul className="flex space-x-6 text-gray-700 font-medium uppercase text-sm">
            <li>
              <NavLink to="/user/dashboard" className={({ isActive }) => `${navLinkClass} ${isActive ? activeClass : ""}`}>
                Home
              </NavLink>
            </li>

            <li>
              <NavLink to="/about" className={({ isActive }) => `${navLinkClass} ${isActive ? activeClass : ""}`}>
                About
              </NavLink>
            </li>

            {/* Jobs Dropdown */}
            <li className="relative group">
              <span className={`cursor-pointer flex items-center ${isJobsRoute ? activeClass : "hover:text-[#00B074]"}`}>
                Jobs
                <svg className="w-4 h-4 ml-1" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M5.25 7L10 11.75 14.75 7z" />
                </svg>
              </span>

              {/* ONLY show dropdown on hover */}
              <ul className="absolute hidden group-hover:block bg-white shadow rounded-md min-w-[150px]">
                <li>
                  <NavLink to="/user/jobs" className={({ isActive }) => `block px-4 py-2 hover:bg-gray-100 ${isActive ? activeClass : ""}`}>
                    Posts
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/user/jobs/freelance" className={({ isActive }) => `block px-4 py-2 hover:bg-gray-100 ${isActive ? activeClass : ""}`}>
                    Categories
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* Freelance Dropdown */}
            <li className="relative group">
              <span className={`cursor-pointer flex items-center ${isFreelanceRoute ? activeClass : "hover:text-[#00B074]"}`}>
                Freelance
                <svg className="w-4 h-4 ml-1" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M5.25 7L10 11.75 14.75 7z" />
                </svg>
              </span>

              <ul className="absolute hidden group-hover:block bg-white shadow rounded-md min-w-[150px]">
                <li>
                  <NavLink to="/job-category" className={({ isActive }) => `block px-4 py-2 hover:bg-gray-100 ${isActive ? activeClass : ""}`}>
                    List
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/testimonial" className={({ isActive }) => `block px-4 py-2 hover:bg-gray-100 ${isActive ? activeClass : ""}`}>
                    Testimonial
                  </NavLink>
                </li>
              </ul>
            </li>

            <li>
              <NavLink to="/contact" className={({ isActive }) => `${navLinkClass} ${isActive ? activeClass : ""}`}>
                Contact
              </NavLink>
            </li>
          </ul>

          <NavLink to="/explore" className="hidden lg:inline-block bg-[#00B074] text-white py-3 px-6 rounded-none ml-4 hover:bg-[#00925e] transition">
            Explore More <i className="fa fa-arrow-right ml-2"></i>
          </NavLink>
        </div>
      </nav>
    </div>
  );
};

export default DefaultHeader;
